_collow.components.CourseMenu = class CourseMenu extends (
  _collow.components.Base
) {
  root;
  elements;
  params;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    [elements.showbutton, elements.hidebutton].forEach((button) =>
      this.listen(button, "click", this.toggleMenu)
    );

    this.progressTracker()
    try {
      if (this.activeSection[0].children[0].children[1]) {
        this.getActiveSection();
        this.listen(this.activeSection[0].children[0].children[1], "click", this.getActiveSection);
      }
    } catch { }

    this.listen(
      document.body,
      "_collow.logout",
      () => (window.location.href = "/")
    );
  }

  activeSection = document.getElementsByClassName('activeSection')
  arrowSection = document.querySelector(".collapse-button")
  loadBuffer = 0

  /* shows the highlight on the main section the user is on if the section is collapsed*/
  getActiveSection = () => {
    if (document.getElementById('doubleActiveCheck')) {
      return
    }
    if (this.activeSection[0].hasAttribute('open')) {
      if (this.loadBuffer === 0) {
        this.activeSection[0].setAttribute('data-course-status', "")
        this.loadBuffer = 1;
        return
      }
      this.activeSection[0].setAttribute('data-course-status', "active")
    } else {
      if (this.loadBuffer === 0) {
        this.activeSection[0].setAttribute('data-course-status', "active")
        this.loadBuffer = 1;
        return
      }
      this.activeSection[0].setAttribute('data-course-status', "")
    }

  }

  /** Progress tracker component */
  progressTracker = async () => {
    const localData = JSON.parse(localStorage.progressJson)
    const pathAPI = document.querySelectorAll("aside")[0].getAttribute("data-component:pathapi")
    const currentCourse = this.params.coursename
    let progressCourseId = null;
    let courseRegistrationId = null;
    let completedVal = null;

    for (let i = 0; i < localData.course_registrations.length; i++) {
      if (localData.course_registrations[i].course.course_name === currentCourse) {
        progressCourseId = localData.course_registrations[i].course_id;
        courseRegistrationId = localData.course_registrations[i].course_registration_id
        completedVal = (localData.course_registrations[i].status === 2) ? true : false //if the course has been completed
      }
    }

    const getCourseSteps = await fetch(this.params.pathapi + `/course/steps?course_id=${progressCourseId}`, {
      method: "get",
      headers: {},
    });

    const allCourseSteps = await getCourseSteps.json();

    const getCompletedSteps = await fetch(this.params.pathapi + `/course_registration/${courseRegistrationId}/elements_done`, {
      method: "get",
      headers: {
        Authorization: localStorage.getItem("token")
      }
    });
    const completedCourseSteps = await getCompletedSteps.json()

    let cleanCompletedCourseSteps = []
    let collectedIds = []
    completedCourseSteps.forEach(step => {
      if ((step.status === 1) && !(collectedIds.includes(step.course_element_id))) {
        cleanCompletedCourseSteps.push(step)
        collectedIds.push(step.course_element_id)
      }
    })

    const allMixed = cleanCompletedCourseSteps.map(e => {
      const fullCourse = allCourseSteps.filter(course => course.course_element_id === e.course_element_id)
      return { ...e, ...fullCourse[0] }
    })

    allMixed.forEach(e => {
      const element = document.querySelector(`a[href*="${e.path}"]`)
      if (!element) return
      element.parentElement.classList.add('complete')
    })

    const completedContainer = document.querySelectorAll('.complete');
    completedContainer.forEach(e => {
      try {
        const i = e.querySelector("#completion-icon-component")
        i.classList.remove('fa-regular', 'fa-circle', 'fa-circle-question');
        i.classList.add('fa-solid', 'fa-circle-check');
        i.style.color = '#0CAD2F'
      } catch { }
    });

    const progressBar = document.getElementsByClassName('completion-bar')[0]
    progressBar.setAttribute("max", allCourseSteps.length);

    if (completedVal === true) { // true is returned only if the course has already been completed, in this case, everything can be marked as complete
      progressBar.setAttribute("value", allCourseSteps.length)
      document.getElementsByClassName('completion-steps')[0].textContent = `${allCourseSteps.length}/${allCourseSteps.length}`
      document.getElementsByClassName('completion-percentage')[0].textContent = `100%`

    } else {
      progressBar.setAttribute("value", cleanCompletedCourseSteps.length);
      document.getElementsByClassName('completion-steps')[0].textContent = `${cleanCompletedCourseSteps.length}/${allCourseSteps.length} ${this.params.steptranslation}`
      document.getElementsByClassName('completion-percentage')[0].textContent = `${((cleanCompletedCourseSteps.length / allCourseSteps.length) * 100).toFixed(1)}%`
    }
  }

  /** tracking state of menu */
  toggleMenu = () => {
    const collapsedState =
      this.root.getAttribute("course-collapsed") == "true" ? false : true;
    this.root.setAttribute("course-collapsed", collapsedState);
  };
};
